import React from "react";
//#region types
import { WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";
import { AccountingFormTypes } from "models/formTypes";
import { DateConstants } from "utils/constants";
//#endregion
//#region components
import { useFilterContext } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useReconciliationReportHelpers(
  initialFilterReconciliationId: number,
  initialReconciliation: string,
  getReport: (
    filter: WintSuperkollAPIModelFinancialReport.AuditReportFilter
  ) => Promise<WintSuperkollAPIModelFinancialReport.FinancialReport>
) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [result, setResult] = React.useState<WintSuperkollAPIModelFinancialReport.FinancialReportRow[]>([]);
  const [filter, setFilter] = React.useState<WintSuperkollAPIModelFinancialReport.AuditReportFilter>();
  const { filter: pageFilter, setFilter: setPageFilter } =
    useFilterContext<AccountingFormTypes.ReconciliationReportFilter>();

  const [startDate, setStartDate] = React.useState<Date | undefined>();
  const [endDate, setEndDate] = React.useState<Date | undefined>();
  const [startDateHeader, setStartDateHeader] = React.useState<string>("iB");
  const [endDateHeader, setEndDateHeader] = React.useState<string>("uB");

  React.useEffect(() => {
    if (pageFilter?.reconciliationId === undefined || pageFilter.reconciliationId === 0)
      setPageFilter({ reconciliationId: initialFilterReconciliationId, reconciliation: initialReconciliation }, true);
  }, [initialFilterReconciliationId, initialReconciliation, setPageFilter, pageFilter]);

  React.useEffect(() => {
    const updateFilter = {
      ...(filter ?? ({} as WintSuperkollAPIModelFinancialReport.AuditReportFilter)),
      reconciliationId: pageFilter?.reconciliationId,
    };

    updateFilter.reconciliationId = pageFilter?.reconciliationId ?? initialFilterReconciliationId;

    if (JSON.stringify(filter) !== JSON.stringify(updateFilter)) setFilter(updateFilter);
  }, [initialFilterReconciliationId, filter, pageFilter]);

  React.useEffect(() => {
    if (filter) {
      setLoading(true);

      if (filter.reconciliationId) {
        getReport(filter)
          .then((res) => {
            setResult(res.rows ?? []);

            setStartDate(res.startDate);
            setStartDateHeader(
              res.startDate
                ? LocalizationHelperInstance.getFormattedDate(res.startDate, DateConstants.DateMonthYearShortConfig)
                : "iB"
            );

            setEndDate(res.endDate);
            setEndDateHeader(
              res.endDate
                ? LocalizationHelperInstance.getFormattedDate(res.endDate, DateConstants.DateMonthYearShortConfig)
                : "uB"
            );
          })
          .finally(() => setLoading(false));
      }
    }
  }, [filter]);
  return { result, filter, loading, pageFilter, startDate, endDate, startDateHeader, endDateHeader };
}

export default useReconciliationReportHelpers;
